/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { REGULAR_DRIVER_OTHER, SALES_ADDRESS, MARITAL_STATUS, REGULAR_CELLPHONE_REGISTRATION_NUMBER, PORTABLE_POSSESSIONS_RISK, CELLPHONE_CASE } from '../../../routes/routes';
import './RegularDriver.css';
import { ProgressBar, Button, Dropdown, Image } from 'react-bootstrap';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { addCarToQuote, postRegularDriverFlow, setRegularDriver, setSelectedDriver } from '../../../actions/salesActions';
import { PRODUCT_BLING } from '../../../constants/constants';

class RegularDriver extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            regularDriverList: [],
            selectedRegularDriver: '',
            selectedRegularDriverDropdown: false,
            loggedIn: this.props.auth.uid ? true : false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.getRegularDriver = this.getRegularDriver.bind(this);
        this.handleRegularDriverSelection = this.handleRegularDriverSelection.bind(this);
        this.handleSelectedRegularDriverDropdownToggle = this.handleSelectedRegularDriverDropdownToggle.bind(this);
    }

    async componentDidMount() {
        if (this.state.regularDriverList.length === 0) {
            this.getRegularDriver();
        }
    }

    async handleRegularDriverSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let coverItem = this.state.regularDriverList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedRegularDriver: coverItem[0] });
        this.setState({ nextDisabled: coverItem[0] === undefined });
    }

    async handleSelectedRegularDriverDropdownToggle(e: any) {
        await this.setState({
            selectedRegularDriverDropdown: !this.state.selectedRegularDriverDropdown
        });
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleClick() {
        let selectedDriver = this.state.selectedRegularDriver;
        if (selectedDriver.description === "Someone else") {
            this.props.dispatchsetSelectedDriver(selectedDriver.description)
            this.props.dispatchRedirectTo(REGULAR_DRIVER_OTHER)
        }
        else {
            this.props.dispatchSetRegularDriver(selectedDriver)
            if (this.props.sales.quoteType === PRODUCT_BLING) {
                this.props.dispatchRedirectTo(PORTABLE_POSSESSIONS_RISK)
            }
            else {
                this.props.dispatchRedirectTo(MARITAL_STATUS)
            }
        }
    }

    async handleBack(e: any) {
        if (this.props.sales.quoteType === PRODUCT_BLING) {
            this.props.dispatchRedirectTo(CELLPHONE_CASE)
        }
        else {
            this.props.dispatchRedirectTo(SALES_ADDRESS)
        }
    }

    async getRegularDriver() {
        await postToController(this.props.dispatch, 'GetRegularDriverSelection', JSON.stringify({})).then(async (response) => {
            await this.setState({ regularDriverList: response });
            return true;
        })
    }

    public render() {
        let regularDriverDrop = [];
        if (this.state.regularDriverList.length > 0) {
            regularDriverDrop = this.state.regularDriverList.map((item) => {
                return <Dropdown.Item eventKey={item.id.toString()} key={item.id.toString()}>{item.description}</Dropdown.Item>
            });
        }
        const quoteType = this.props.sales.quoteType;
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={50} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Regular driver/user"></div>
                                        </div>
                                        {quoteType !== "PRODUCT_BLING" ?
                                            <div className="ssp-regular-driver-user-main-contentholder mt-21px mobile-mt-17px mb-28px mobile-mb-30px text-center">
                                                <div className="font-size-16px font-weight-bold mb-11px line-height-normal">Who drives your car (the regular driver)</div>
                                                <div className="font-size-16px font-weight-500 line-height-normal">The regular driver is the person who will drive the car most often during any monthly period.  It’s very important that you give us the correct info regarding the regular driver as this is vital to determine your premium and the acceptance of your cover.</div>
                                            </div> : <div className="ssp-regular-driver-user-main-contentholder-bling mt-21px mobile-mt-17px mb-28px mobile-mb-30px text-center">
                                                <div className="font-size-16px font-weight-500 line-height-normal">Please tell us who's going to use the phone you're insuring</div>
                                            </div>
                                        }
                                        {this.props.sales.quoteType === PRODUCT_BLING && this.state.selectedRegularDriver && <div className="row noma text-left"><label className="left-align temp-text-box-label pl-1 mb-6px col-12">Select regular cellphone user</label></div>}
                                        <div className="row noma">
                                            <div className="col-12 nopa form-control dropdown-holder">
                                                <Dropdown
                                                    id="regularDriver-select-dropdown"
                                                    className="fit-full"
                                                    onSelect={this.handleRegularDriverSelection}
                                                    onToggle={this.handleSelectedRegularDriverDropdownToggle}>
                                                    <Dropdown.Toggle id="dropdown-basic">
                                                        <div className="row dropdown-height">
                                                            <div className="dropdown-basic-title-text col-11">
                                                                {this.state.selectedRegularDriver.description}
                                                                {!this.state.selectedRegularDriver &&
                                                                    (quoteType != PRODUCT_BLING ? <p>Choose an option</p> : <p>Select regular cellphone user</p>)
                                                                }
                                                            </div>
                                                            <Image src='Images/Bling/Dropdown.svg' className={this.state.selectedRegularDriverDropdown ? 'visible' : 'invisible'} alt="" />
                                                            <Image src='Images/Bling/Dropdown.svg' className={this.state.selectedRegularDriverDropdown ? 'invisible' : 'visible'} alt="" />
                                                        </div>
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu id='regularDriverDropDown'>
                                                        {regularDriverDrop}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                        <div className="row justify-content-center mt-40px">
                                            <div className="col-lg-4 col-md-4 col-xs-12 col-sm-12 regular-driver-user-button-holder">
                                                <Button className="btn btn-block button-width btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                            </div>
                                        </div>
                                        {quoteType !== "PRODUCT_BLING" &&
                                            <div className="please-note-regular-driver mt-40px">
                                                <p className="mb-2px font-weight-bold">Please note</p>
                                                <p className="mb-0px">You need to let us know immediately if the regular driver of the car changes, like if you give the car to your child, or if your spouse starts using it more than you do.</p>
                                            </div>
                                            }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        cart: state.cart,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchPostRegularDriver: () => dispatch(postRegularDriverFlow()),
        dispatchRedirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetRegularDriver: (regularDriver: any) => dispatch(setRegularDriver(regularDriver)),
        dispatchsetSelectedDriver: (desription: any) => dispatch(setSelectedDriver(desription))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RegularDriver);